import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./ModalShell.css"

export default function ModalShell({ title, wide, children, footer, onClose }) {
  const overlayRef = useRef(null);
  const dialogRef  = useRef(null);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  useEffect(() => {
    const dialog = dialogRef.current;
    const prevActive = document.activeElement;
    requestAnimationFrame(() => dialog?.focus());
    const onKeyDown = (e) => {
      if (e.key === "Escape") { e.stopPropagation(); onClose?.(); }
      if (e.key === "Tab") {
        const f = dialog.querySelectorAll(
          'a[href],button,textarea,input,select,[tabindex]:not([tabindex="-1"])'
        );
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    dialog?.addEventListener("keydown", onKeyDown);
    return () => { dialog?.removeEventListener("keydown", onKeyDown); prevActive?.focus?.(); };
  }, [onClose]);

  const onOverlayDown = (e) => { if (e.target === overlayRef.current) onClose?.(); };

  return createPortal(
    <div className="sem-modal-overlay" ref={overlayRef} onMouseDown={onOverlayDown}>
      <div
        className={`sem-modal-inner ${wide ? "sem-modal-inner--wide" : ""}`}
        role="dialog" aria-modal="true" tabIndex={-1} ref={dialogRef}
      >
        <div className="sem-modal-header">
          <h3 className="sem-title">{title}</h3>

          {/* Красивый «Х» */}
          <button
  type="button"
  className="sem-modal-close"
  aria-label="Close"
  title="Close"
  onClick={onClose}
>
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M18 6L6 18M6 6l12 12"
          stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
</button>


        </div>

        <div className="sem-modal-body">
          {children}
          <div style={{ height: 8 }} />
        </div>

        {footer && (
          <div className="sem-modal-actions">
            {footer}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}
